import { Box, Grid, styled } from '@mui/material';

const StyledPlansContainer = styled(Grid)(({ theme }) => ({
  textAlign: 'center',
  alignItems: 'center',
  marginBottom: theme.spacing(3),
  '& .buttonGroup': {
    display: 'flex',
    justifyContent: 'center',
    [theme.breakpoints.up('sm')]: {
      justifyContent: 'flex-start',
    },
    [theme.breakpoints.up('md')]: {
      justifyContent: 'center',
    },
  },
  '& .currencySelector': {
    '& > div': {
      alignItems: 'center',
      justifyContent: 'center',
      [theme.breakpoints.up('sm')]: {
        justifyContent: 'flex-end',
      },
    }
  }
}));

const StyledPlanItem = styled(Box)(({ theme }) => ({
  height: '100%',
  border: '1px solid #DCE0E4',

  '&.planHighlight': {
    border: `2px solid ${theme.palette.primary.main}`
  },
  '& .MuiChip-root': {
    zIndex: 1,
    height: 26,
    fontSize: 10,
    textTransform: 'uppercase',
    color: theme?.palette?.primary?.main,
  },
  '& .mostPopular': {
    backgroundColor: '#fff',
    margin: theme.spacing(1),
    position: 'absolute',
  },
  '& .priceLabel': {
    backgroundColor: theme?.palette?.primary?.lighter,
    margin: '0 auto',
    display: 'flex',
    width: 'fit-content',
    marginTop: '-16px',
    position: 'relative',
  },
}));

export {
  StyledPlansContainer,
  StyledPlanItem
};
